function qs(sel, root) {
  return (root || document).querySelector(sel);
}

export function initNewsletter() {
  var form = qs("#newsletterForm");
  var alertBox = qs("#newsletterAlert");
  if (!form || !alertBox) return;

  function show(msg) {
    alertBox.textContent = msg;
    alertBox.hidden = false;
    window.clearTimeout(show._t);
    show._t = window.setTimeout(function () {
      alertBox.hidden = true;
      alertBox.textContent = "";
    }, 3500);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var input = form.querySelector('input[name="email"]');
    var email = (input && input.value ? input.value : "").trim();

    if (!email) {
      show("من فضلك اكتب بريدك الإلكتروني.");
      return;
    }

    // HTML5 validation (type=email)
    if (input && !input.checkValidity()) {
      show("من فضلك اكتب بريد إلكتروني صحيح.");
      return;
    }

    show("تم تسجيل البريد محليًا. الصفحة حالياً static بدون إرسال للسيرفر.");
    form.reset();
  });
}